import { z } from 'zod';

import { cursor } from '@nesso/common-contracts/cursor';
import { defineQuery } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { PAYMENT_LIST_ITEM_KINDS, paymentListItemSchema } from './payment.models';
import { clientScopeSchema } from './session-charge.queries';

export const GET_PAYMENT_LIST_TYPE = 'payment/get-list';

export const getPaymentList = defineQuery(
    GET_PAYMENT_LIST_TYPE,
    cursor.input.extend(clientScopeSchema.shape).extend({
        // `z.string().pipe(...)` so a raw query string satisfies `z.input` while the reader sees the union.
        kind: z
            .string()
            .pipe(z.enum(PAYMENT_LIST_ITEM_KINDS))
            .optional()
            .meta(metadata.nonSensitive),
    }),
    cursor.output.extend({ items: z.array(paymentListItemSchema) }),
);
